module.exports = __webpack_public_path__ + "1bc9dad766fd9c06dca52e7b9c65dcf0.png";